import { render, staticRenderFns } from "./alarms-expand-panel-remediation.vue?vue&type=template&id=4625c2fc&"
import script from "./alarms-expand-panel-remediation.vue?vue&type=script&lang=js&"
export * from "./alarms-expand-panel-remediation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports